@if (isLink(item) && !isFunction(item.route) && isAuthorizedToShow(item.availableTo)) {
  <a
    [fragment]="item.fragment"
    [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
    [routerLink]="item.route"
    class="vex-sidenav-item"
    matRipple
    matRippleColor="var(--sidenav-item-ripple-color)"
    routerLinkActive="vex-sidenav-item--active">
    @if (level === 0) {
      <mat-icon [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
    }
    <span class="vex-sidenav-item__label">{{ item.label }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
      class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
    }
  </a>
}

@if (isLink(item) && isFunction(item.route)) {
  <div (click)="item.route()"
    class="vex-sidenav-item"
    matRipple
    matRippleColor="var(--sidenav-item-ripple-color)"
    routerLinkActive="vex-sidenav-item--active">
    @if (level === 0) {
      <mat-icon [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
    }
    <span class="vex-sidenav-item__label">{{ item.label }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
      class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
    }
  </div>
}

@if (isDropdown(item)) {
  <div (click)="toggleOpen()"
    [class.vex-sidenav-item--active]="isOpen || isActive"
    [class.vex-sidenav-item--open]="isOpen"
    class="vex-sidenav-item"
    matRipple
    matRippleColor="var(--sidenav-item-ripple-color)">
    @if (level === 0) {
      <mat-icon [svgIcon]="item.icon" class="vex-sidenav-item__icon"></mat-icon>
    }
    <span class="vex-sidenav-item__label">{{ item.label }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
      class="vex-sidenav-item__badge">{{ item.badge.value }}</span>
    }
    <mat-icon class="vex-sidenav-item__dropdown-icon" svgIcon="mat:keyboard_arrow_right"></mat-icon>
  </div>
  <div [@dropdown]="isOpen" class="vex-sidenav-item__dropdown">
    @for (subItem of item.children; track subItem) {
      <vex-sidenav-item [item]="subItem" [level]="level + 1"></vex-sidenav-item>
    }
  </div>
}


@if (isSubheading(item) && isAuthorizedToShow(item.availableTo)) {
  <div class="vex-sidenav-subheading">{{ item.label }}</div>
  @for (subItem of item.children; track subItem) {
    <vex-sidenav-item [item]="subItem" [level]="0"></vex-sidenav-item>
  }
}

